import firebase from 'gatsby-plugin-firebase';

const deleteSCurve = async (id: string): Promise<void> => {
  await firebase.database().ref(`/scurve/${id}`).remove();
};

export default deleteSCurve;
